// Importaciones de estilos y librerías.
import './App.css'; // Importa los estilos CSS específicos para este componente.
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Importa los componentes necesarios de React Router para manejar el enrutamiento de la aplicación.

// Importación de todos los componentes de página.
import Home from './page/Home'; // Página de inicio.
import Servicios from './page/Servicios'; // Página de listado de servicios.
import Contacto from './page/Contacto'; // Página de contacto.
import Error from './page/Error'; // Página para manejar rutas no encontradas (404).
import Privacidad from './page/Privacidad'; // Página de políticas de privacidad.

// Importación de componentes reutilizables.
import Navbar from './component/Navbar'; // Barra de navegación superior.
import Footer from './component/Footer'; // Pie de página.
import ScrollToTopOnMount from './component/ScrollToTopOnMount'; // Componente que hace scroll hacia arriba al cambiar de ruta.

// Importación de los formularios específicos de servicios.
import FormularioEtiquetaTisax from './Formularios/FormularioEtiquetaTisax';
import FormularioServicioCISO from './Formularios/FormularioServicioCISO';
import FormularioCertificadoISO27001 from './Formularios/FormularioCertificacionISO27001';
import FormularioCertificacionISO22301 from './Formularios/FormularioCertificacionISO22301';
import FormularioGeneral from './component/FormularioGeneral'; // Formulario de contacto general.
import RecursosPage from './page/RecursosPage'; // Página de recursos.

// Importación de las páginas de visualización de certificados.
import Certificado1 from './todosLosCertificados/Certificado1';
import Certificado2 from './todosLosCertificados/Certificado2';
import Certificado3 from './todosLosCertificados/Certificado3';
import Certificado4 from './todosLosCertificados/Certificado4';
import Certificado5 from './todosLosCertificados/Certificado5';
import Certificado6 from './todosLosCertificados/Certificado6';
import Certificado7 from './todosLosCertificados/Certificado7';
import Certificado8 from './todosLosCertificados/Certificado8';
import Certificado9 from './todosLosCertificados/Certificado9';
import Certificado10 from './todosLosCertificados/Certificado10';
import Certificado11 from './todosLosCertificados/Certificado11';
import Certificado12 from './todosLosCertificados/Certificado12';
import Certificado13 from './todosLosCertificados/Certificado13';
import Certificado14 from './todosLosCertificados/Certificado14.js';
import Certificado15 from './todosLosCertificados/Certificado15';
import Certificado16 from './todosLosCertificados/Certificado16';
import Certificado17 from './todosLosCertificados/Certificado17';
import Certificado18 from './todosLosCertificados/Certificado18';

/**
 * Componente principal de la aplicación.
 * Funciona como el orquestador general, configurando el enrutamiento
 * y renderizando los componentes comunes como la barra de navegación y el pie de página.
 */
function App() {
  return (
    // El componente Router envuelve toda la aplicación para habilitar el enrutamiento.
    <Router>
      {/* Este componente asegura que al navegar a una nueva página, la vista comience desde la parte superior. */}
      <ScrollToTopOnMount />

      {/* Contenedor principal de la aplicación con la clase CSS "App". */}
      <div className="App">
        {/* La barra de navegación se muestra en todas las páginas. */}
        <Navbar />

        {/* El componente Routes define el área donde se renderizarán las diferentes páginas según la URL. */}
        <Routes>
          {/* --- Rutas para las páginas principales --- */}
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/Contacto" element={<Contacto />} />

          {/* --- Rutas para los formularios de solicitud de servicios --- */}
          <Route path='/servicios/formulario-etiqueta-tisax' element={<FormularioEtiquetaTisax />} />
          <Route path='/servicios/formulario-servicio-de-ciso' element={<FormularioServicioCISO />} />
          <Route path='/servicios/formulario-certificación-iso27001' element={<FormularioCertificadoISO27001 />} />
          <Route path='/servicios/formulario-certificación-iso22301' element={<FormularioCertificacionISO22301 />} />

          {/* --- Ruta para el formulario de consultas generales --- */}
          <Route path='/consultas' element={<FormularioGeneral />} />

          {/* --- Ruta para la página de recursos --- */}
          <Route path='/recursos' element={<RecursosPage />} />

          {/* --- Rutas únicas para la validación y visualización de certificados --- */}
          {/* Cada ruta corresponde a un ID de certificado único. */}
          <Route path='/f4hpb0omog5ce' element={<Certificado1 />} />
          <Route path='/6bvpdt5os05lg' element={<Certificado2 />} />
          <Route path='/6sdxjwe5ma' element={<Certificado3 />} />
          <Route path='/9j4jvj05av' element={<Certificado4 />} />
          <Route path='/16uqyf0yzrz5jt' element={<Certificado5 />} />
          <Route path='/69gr6xvcgtt5al' element={<Certificado6 />} />
          <Route path='/bxfwauv5jl' element={<Certificado7 />} />
          <Route path='/f0c4e2f85cp' element={<Certificado8 />} />
          <Route path='/hp1lotl5jm' element={<Certificado9 />} />
          <Route path='/r9tvfi35ll' element={<Certificado10 />} />
          <Route path='/rrwdn7r5rt' element={<Certificado11 />} />
          <Route path='/u7l6p0gme5ao' element={<Certificado12 />} />
          <Route path='/umfzeiz5rki5ja' element={<Certificado13 />} />
          <Route path='/xhvyoneempz5ag' element={<Certificado14 />} />
          <Route path='/zrro6xh5zc' element={<Certificado15 />} />
          <Route path='/73Sxjwudh3D' element={<Certificado16 />} />
          <Route path='/6sdxjwudh7A' element={<Certificado17 />} />
          <Route path='/PFfhnuig75T' element={<Certificado18 />} />

          {/* --- Ruta de fallback --- */}
          {/* Esta ruta se activa si ninguna de las anteriores coincide, mostrando una página de error. */}
          <Route path="*" element={<Error />} />
        </Routes>

        {/* El pie de página se muestra en todas las páginas. */}
        <Footer />
      </div>
    </Router>
  );
};

// Exporta el componente App para que pueda ser utilizado en otras partes de la aplicación, como en `index.js`.
export default App;
